<template>
  <!--输入密码-->
    <pops :show="isShowPassword" :title="'输入密码'" @closePop="_cancelPass" :width="'25%'">
      <div>
        <el-form label-width="100px">
          <el-row>
            <el-col :span="22">
              <el-form-item :span="10" label="密码  :">
                <el-col :span="24">
                  <el-input v-model="confPassword" type="password" :maxlength="10" placeholder="请输入会议密码"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!--确定取消按钮-->
        <div class="btn-box">
          <el-button  @click="_inputDetail" class="indetail mana-query">确定</el-button>
          <el-button @click="_cancelPass" class="cancel mana-query">取消</el-button>
        </div>
      </div>
    </pops>
</template>

<script>
 import pops from '@/components/common/pops/pop'
 import {message} from '@/common/js/messages'
export default {
  components:{
    pops
  },
  props:{
    isShowPassword:{//医院id
      require:true,
      type: Boolean,
    },
  },
  data() {
    return {
        confPassword:""
    }
  },
  methods: {
    _cancelPass(){
      this.$emit("clossPassword");
    },
    _inputDetail(){
      if(this.confPassword.length>0){
        this.$emit("inputPassword",this.confPassword);
      }else{
        message('请输入密码', false)
        return false
      }
    }
  },
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .mana-query
    display: inline-block
    width: 120px
    height: 28px
    line-height: 28px
    background: $color-background-hover
    color: $button-text-color
    text-align: center
    border-radius: 4px
    cursor: pointer
  .indetail , .cancel
      padding: 0
      width: 100px
    .indetail
    margin-left: 50px
  .cancel
    background: $button-del !important;
</style>



// WEBPACK FOOTER //
// passwordInput.vue?786e1811